/* src/app/documents/assessment/assessment.component.scss */
:host {
  --primary: #253b80;
  --primary-dark: #1d2f68;
  --primary-light: #eef2ff;
  --text: #172033;
  --text-secondary: #64748b;
  --border: #e2e8f0;
  --background: #f8fafc;
  --white: #ffffff;
  --success: #15803d;
  --danger: #dc2626;
  display: block;
}
.assessment-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.58);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  animation: fadeIn 0.2s ease;
}
.assessment-modal {
  width: min(1100px, 100%);
  max-height: 94vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--white);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 18px;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.25), 0 8px 20px rgba(15, 23, 42, 0.08);
  animation: slideUp 0.25s ease;
}
.assessment-header {
  min-height: 76px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 22px;
  border-bottom: 1px solid var(--border);
  background: #fff;
}
.assessment-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.assessment-header__icon {
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary);
  background: var(--primary-light);
  border-radius: 12px;
  font-size: 21px;
}
.assessment-header h2 {
  margin: 0;
  color: var(--text);
  font-size: 19px;
  font-weight: 700;
}
.assessment-header p {
  margin: 3px 0 0;
  color: var(--text-secondary);
  font-size: 13px;
}
.assessment-close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: 0.2s;
}
.assessment-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}
.assessment-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  background: var(--background);
  scrollbar-width: thin;
}
.document-info {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  padding: 15px 17px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
}
.document-info__icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--primary);
  background: var(--primary-light);
  border-radius: 10px;
}
.document-info__content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.document-info__label {
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.document-info strong {
  overflow: hidden;
  color: var(--text);
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.assessment-section {
  margin-bottom: 20px;
  padding: 20px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 14px;
}
.section-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 18px;
}
.section-heading h3 {
  margin: 0;
  color: var(--text);
  font-size: 16px;
  font-weight: 700;
}
.section-heading p {
  margin: 4px 0 0;
  color: var(--text-secondary);
  font-size: 13px;
}
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.form-group {
  min-width: 0;
}
.form-group--full {
  grid-column: 1/-1;
}
.form-group label {
  display: block;
  margin-bottom: 7px;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}
.form-group label span {
  color: var(--danger);
}
.form-control {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  color: var(--text);
  font-family: inherit;
  font-size: 14px;
  background: #fff;
  border: 1px solid #dbe2ea;
  border-radius: 9px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.form-control:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.1);
}
.form-control::placeholder {
  color: #94a3b8;
}
.form-control--textarea {
  resize: vertical;
  min-height: 90px;
}
.input-with-suffix {
  position: relative;
}
.input-with-suffix .form-control {
  padding-right: 72px;
}
.input-with-suffix span {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  color: var(--text-secondary);
  font-size: 12px;
}
.btn {
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  border: 0;
  border-radius: 9px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-primary {
  color: #fff;
  background: var(--primary);
}
.btn-primary:hover:not(:disabled) {
  background: var(--primary-dark);
  transform: translateY(-1px);
}
.btn-light {
  color: #475569;
  background: #f1f5f9;
}
.btn-light:hover {
  background: #e2e8f0;
}
.btn-secondary {
  color: var(--primary);
  background: var(--primary-light);
}
.btn-secondary:hover {
  background: #e0e7ff;
}
.question-empty {
  padding: 38px 20px;
  text-align: center;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  background: #fafbfc;
}
.question-empty__icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary);
  background: var(--primary-light);
  border-radius: 50%;
  font-size: 21px;
}
.question-empty h4 {
  margin: 0;
  color: var(--text);
  font-size: 14px;
}
.question-empty p {
  margin: 6px 0 16px;
  color: var(--text-secondary);
  font-size: 13px;
}
.question-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.question-card {
  display: flex;
  gap: 14px;
  padding: 15px;
  border: 1px solid var(--border);
  border-radius: 11px;
  background: #fff;
  transition: 0.2s;
}
.question-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);
}
.question-card__number {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary);
  background: var(--primary-light);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
}
.question-card__content {
  flex: 1;
  min-width: 0;
}
.question-card__top {
  display: flex;
  gap: 8px;
  margin-bottom: 7px;
}
.question-card h4 {
  margin: 0 0 10px;
  color: var(--text);
  font-size: 14px;
  line-height: 1.5;
}
.question-card__actions {
  display: flex;
  align-items: flex-start;
  gap: 5px;
}
.question-card__actions button {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}
.question-card__actions button:hover {
  background: #f1f5f9;
  color: var(--primary);
}
.question-card__actions button:last-child:hover {
  color: var(--danger);
}
.question-type,
.question-points {
  display: inline-flex;
  padding: 4px 8px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 600;
}
.question-type {
  color: var(--primary);
  background: var(--primary-light);
}
.question-points {
  color: #64748b;
  background: #f1f5f9;
}
.question-options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.question-option {
  padding: 5px 9px;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 11px;
}
.assessment-footer {
  min-height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 22px;
  background: #fff;
  border-top: 1px solid var(--border);
}
.assessment-footer__actions {
  display: flex;
  gap: 8px;
}
.assessment-summary {
  display: flex;
  gap: 18px;
  color: var(--text-secondary);
  font-size: 12px;
}
.assessment-summary span {
  display: flex;
  align-items: center;
  gap: 5px;
}
.question-editor-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.35);
}
.question-editor {
  width: min(620px, 100%);
  max-height: 90%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.22);
}
.question-editor__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid var(--border);
}
.question-editor__header h3 {
  margin: 0;
  color: var(--text);
  font-size: 16px;
}
.question-editor__header p {
  margin: 4px 0 0;
  color: var(--text-secondary);
  font-size: 12px;
}
.question-editor__header button {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 7px;
  background: #f8fafc;
  color: #64748b;
  cursor: pointer;
}
.question-editor__body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}
.question-editor__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 20px;
  border-top: 1px solid var(--border);
}
.options-editor {
  margin-top: 20px;
}
.options-editor__heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.options-editor__heading label {
  margin: 0;
}
.options-editor__heading button {
  border: 0;
  background: transparent;
  color: var(--primary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.option-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.option-row input[type=radio],
.option-row input[type=checkbox] {
  flex-shrink: 0;
}
.option-row .form-control {
  flex: 1;
}
.option-row > button {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 7px;
  background: #f8fafc;
  color: #64748b;
  cursor: pointer;
}
.option-row > button:hover:not(:disabled) {
  color: var(--danger);
  background: #fef2f2;
}
.option-row > button:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.true-false-options {
  margin-top: 20px;
}
.true-false-options label {
  display: block;
  margin-bottom: 9px;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}
.true-false-buttons {
  display: flex;
  gap: 10px;
}
.true-false-buttons button {
  flex: 1;
  height: 42px;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: #fff;
  color: #475569;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}
.true-false-buttons button.active {
  color: var(--primary);
  background: var(--primary-light);
  border-color: #a5b4fc;
}
@media (max-width: 700px) {
  .assessment-overlay {
    padding: 10px;
  }
  .assessment-modal {
    max-height: 96vh;
    border-radius: 14px;
  }
  .assessment-body {
    padding: 15px;
  }
  .assessment-section {
    padding: 15px;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
  .form-group--full {
    grid-column: auto;
  }
  .section-heading {
    flex-direction: column;
    gap: 12px;
  }
  .section-heading .btn {
    width: 100%;
  }
  .assessment-footer {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }
  .assessment-footer__actions {
    width: 100%;
  }
  .assessment-footer__actions .btn {
    flex: 1;
  }
  .assessment-summary {
    justify-content: center;
  }
  .question-card {
    position: relative;
  }
  .question-card__actions {
    position: absolute;
    top: 12px;
    right: 12px;
  }
  .question-card__content {
    padding-right: 60px;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(15px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
/*# sourceMappingURL=assessment.component.css.map */
